<template>
  <div id="J_app">
    <transition name="fade" mode="out-in">
      <router-view class="view"></router-view>
    </transition>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import storage from '@/util/storage';

  export default {
    name: 'app',
    watch: {
    },
    methods: {
    },
    created () {
      if (typeof window !== 'undefined') {
        storage.setKey(window.pageData && window.pageData.productId);
      }
    },
    mounted () {
      document.addEventListener('blur', event => {
        if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
          let offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
          let maxOffset = document.documentElement.scrollHeight - document.documentElement.clientHeight;
          if (offset > maxOffset) {
            window.scrollTo(0, maxOffset);
          }
        }
      }, true)
    }
  }
</script>

<style lang="scss">
  img[src=""], img:not([src]){
    opacity:0;
  }
  .pageFixed {
    position: fixed;
    overflow: hidden;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .touch-strip {
    position: relative;
    touch-action: manipulation;
    background: #fff;
    a {
        display: block;
        padding: 8px 33px 8px 0;
        font-size:13px;
        color:#666;
        line-height: 24px;
    }
    .content {
        padding-left: 18px;
        .more {
            float: right;
            font-weight: 300;
            font-size: 14px;
            color: #777893;
        }
    }
    .sub-content {
        padding: 0 12px;
        font-size: 12px;
        color: #999;
    }
    .arrow {
        position: absolute;
        right: 9px;
        top: 50%;
        width: 24px;
        height: 24px;
        transform: translate(0, -50%) scale(0.6);

        &:before,
        &:after {
            content: " ";
            position: absolute;
            left: 50%;
            top: 50%;
            width: 50%;
            height: 2px;
            margin: -1px 0 0 -25%;
            background: #c2c6cc;
        }

        &:before {
            transform: translate(0, -4px) rotate(45deg);
        }

        &:after {
            transform: translate(0, 4px) rotate(-45deg);
        }
    }
  }
</style>


// WEBPACK FOOTER //
// App.vue